import React, { useState, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import _ from 'lodash';

import MaterialTable, { MTableEditRow, MTableToolbar } from 'material-table';
import { forwardRef } from 'react';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import Remove from '@material-ui/icons/Remove';
import ViewColumn from '@material-ui/icons/ViewColumn';
import {
  getUserRoles,
} from '@actions/selectors';
import { constructUrl } from '@src/hooks/useThresholds';
import { MODE_MESSAGES } from '../Constants';
import { Auth } from 'aws-amplify';

const TableStyle = styled.div`
  -webkit-font-smoothing: antialiased;
  width: 100%;

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }

  .MuiInputBase-input,
  .MuiInput-input {
    text-align: center;
    /* border: 2px solid grey; */
    border: 1px solid #d2d6d9 !important;
    border-radius: 5px;
  }

  .MuiInput-underline.Mui-error:after {
    display: none !important;
  }

  .MuiInput-underline:before {
    display: none !important;
  }

  h6 {
    font-size: 1.1rem;
  }
`;

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

const putThreshold = async (apiKey, configName, body, setData, updateRow, resolve, reject, oldData) => {
  fetch(constructUrl(configName), {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': apiKey,
      'Authorization': `${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`,
    },
    body: body,
  })
    .then(response => {
      return response.json();
    })
    .then(dataObj => {
      if (dataObj.message === 'error') {
        alert('Please Provide Input in range of 0-1');
        resolve();
      } else {
        oldData[configName] = updateRow;
        setData(oldData);
        resolve();
      }
    })
    .catch(console.error);
  
}

const DataTable = props => {
  const { thresholds, configName } = props;
  const [data, setData] = useState(thresholds);
  const [isEditMode, setisEditMode] = useState(false);
  const apiKey = useSelector(state => state.keys.key);

  const modeFunc = useCallback(ref => {
    ref ? setisEditMode(true) : setisEditMode(false);
  }, []);

  const groups = useSelector(getUserRoles);
  
  const materialTableProps = {
    onBulkUpdate: selectedRows =>
      new Promise((resolve, reject) => {
        const rows = Object.values(selectedRows);
        const updateRow = new Array(...thresholds[configName]);
        
        rows.forEach(list => {
          let index = list.oldData.tableData.id;
          updateRow[index] = list.newData;
        });
        
        const body = JSON.stringify(
          (() => {
            let result = {};
            updateRow.forEach(element => {
              let usefulKeys = _.omit(element, ['list', 'tableData']);
              result[element.list] = { ...usefulKeys };
            });
            return result;
          })()
        );
        const response = putThreshold(apiKey, configName, body, setData, updateRow, resolve, reject, data);
      }),
  };

  const headerStyle = {
    // backgroundColor: '#efefef',
    textAlign: 'justify',
    fontWeight: 'bold',
  };

  return (
    <TableStyle>
      <MaterialTable
        icons={tableIcons}
        columns={[
          {
            title: 'list type',
            field: 'list',
            editable: 'never',
            cellStyle: {
              textAlign: 'justify',
            },
            headerStyle: headerStyle,
          },
          {
            title: 'freetext value',
            field: 'freetext',
            type: 'numeric',
            cellStyle: {
              textAlign: 'center',
            },
            headerStyle: headerStyle,
            validate: rowData =>
              rowData.freetext > 1 || rowData.freetext < 0
                ? 'range of input (0-1)'
                : '',
          },
          {
            title: 'name value',
            field: 'name',
            type: 'numeric',
            cellStyle: {
              textAlign: 'center',
            },
            headerStyle: headerStyle,
            validate: rowData =>
              rowData.name > 1 || rowData.name < 0
                ? 'range of input (0-1)'
                : '',
          },
        ]}
        components={{
          EditRow: props => {
            return <MTableEditRow {...props} ref={modeFunc}></MTableEditRow>;
          },
          Toolbar: props => (
            <div style={{ background: '#efefef' }}>
              <MTableToolbar {...props} />
              {/* {isEditMode ? <EditMode></EditMode> : <ViewMode></ViewMode>} */}
            </div>
          ),
        }}
        options={{
          actionsColumnIndex: -1,
          search: false,
          paging: false,
        }}
        data={data[configName]}
        editable={groups.includes('Admin') ? materialTableProps : ''}
        title={
          !isEditMode
            ? MODE_MESSAGES[configName].view
            : MODE_MESSAGES[configName].edit
        }
      />
    </TableStyle>
  );
};

export default DataTable;
